
export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '認証工場の安心',
      description: '国土交通省認証工場として、法定基準に基づいた確実な整備を実施'
    },
    {
      icon: 'ri-team-line',
      title: '経験豊富な整備士',
      description: '国家資格を持つベテラン整備士が、お客様のお車を丁寧に点検・整備'
    },
    {
      icon: 'ri-time-line',
      title: '迅速な対応',
      description: '緊急時は24時間対応。お客様のカーライフをしっかりサポート'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '明確な料金体系',
      description: '事前見積もりで安心。追加料金が発生する場合は必ずご相談'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
            選ばれる理由
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            地域のお客様に愛され続ける理由があります
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${feature.icon} text-3xl text-orange-500`}></i>
              </div>
              <h3 className="text-lg font-bold text-slate-800 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
